module.exports = __webpack_public_path__ + "data/alerts.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/alerts/alerts.json
// module id = NNTt
// module chunks = 1